import {ROWS_PER_PAGE} from '../constants/rowsPerPage';
import {getInfiniteScrollBoundaryOffset} from './getInfiniteScrollBoundaryOffset';

export function getNextInfiniteScrollPage(
  dataLength: number,
  scrollAttemptedOffset?: number
): number {
  return getInfiniteScrollBoundaryOffset(dataLength, scrollAttemptedOffset) / ROWS_PER_PAGE + 1;
}
